import SimplePostEditor from "./SimplePostEditor";
import { getHTMLfromRawState } from "./SimplePostEditor";

export default SimplePostEditor;
export { getHTMLfromRawState };
